import {HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";

export default class RestHelper {

  public static API_BASE_URL: string = environment.baseApiUrl

  public static headers = new HttpHeaders({
    // 'Content-Type': 'application/json',
  });

  public static requestOptions = {headers: this.headers};

  public static buildParams(sortby: string = "", sorttype: string = "", offset: number, tablelength: number): URLSearchParams {
    const urlSearchParams = new URLSearchParams();
    if (offset === 0) {
      offset = -1
    }
    urlSearchParams.set("offset", offset.toString())
    urlSearchParams.set("length", tablelength.toString())
    if (sortby !== "") {
      urlSearchParams.set("sortby", sortby);
    }
    if (sorttype !== "") {
      urlSearchParams.set("sorttype", sorttype);
    }
    return urlSearchParams
  }
}
